export enum CopilotTrackerLabelType {
	BUBBLE = 'bubble',
	MESSAGE = 'message',
	AI_BUBBLES = 'ai_bubbles',
	ERROR = 'error',
	NEW_CHAT = 'new_chat',
	PREVIOUS_CHAT = 'previous_chat',
	BANNER = 'banner',
}
